/**
 * Converts a string into a handleized version.
 * This is roughly equivalent to the Shopify liquid handleize filter.
 * Removes leading and trailing whitespace, replaces spaces with dashes, and converts to lowercase.
 *
 * @param str - The string to handleize.
 * @returns The handleized version of the string.
 */
export function handleize(str: string) {
  return str.trim().replace(/\s/g, '-').toLowerCase();
}
